/*
 * MSE_SWYM_REMIND_POPUP_V5_20260918
 * Visual only.
 */
(() => {
  'use strict';

  const M =
    'MSE_SWYM_REMIND_POPUP_V5_20260918';

  const norm = (v) =>
    String(v || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  function imp(el, prop, value) {
    if (!el) return;
    if (el.style.getPropertyValue(prop) === value &&
        el.style.getPropertyPriority(prop) === 'important') return;
    el.style.setProperty(
      prop,
      value,
      'important'
    );
  }

  function findPopup(email) {
    let el = email;

    for (let i = 0; i < 12 && el; i++) {
      const t = norm(el.textContent);

      if (
        t.includes('benachrichtige mich') &&
        (
          t.includes('info an mich') ||
          t.includes('wieder verfügbar')
        )
      ) {
        return el;
      }

      el = el.parentElement;
    }

    return null;
  }

  function styleLeafText(popup) {
    popup
      .querySelectorAll(
        'h1,h2,h3,h4,h5,h6,p,span,div,label'
      )
      .forEach((el) => {
        /*
         * Nur echte Textblöcke bearbeiten,
         * keine großen Wrapper.
         */
        const childText =
          [...el.children]
            .some((child) =>
              norm(child.textContent)
              === norm(el.textContent)
            );

        if (childText) return;

        const t =
          norm(el.textContent);

        if (!t) return;

        imp(
          el,
          'font-family',
          'inherit'
        );

        /*
         * Hauptüberschrift.
         */
        if (
          t.includes('info an mich') &&
          t.includes('artikel') &&
          t.includes('verfügbar') &&
          t.length < 100
        ) {
          imp(el, 'font-size', '27px');
          imp(el, 'line-height', '1.12');
          imp(el, 'font-weight', '700');
          imp(el, 'letter-spacing', '0');
          imp(el, 'text-transform', 'none');
          imp(el, 'margin', '0 20px 12px');
          imp(el, 'padding', '0');
          imp(el, 'text-align', 'center');
        }

        /*
         * Erklärung.
         */
        if (
          t.includes(
            'wir senden dir eine e-mail'
          ) &&
          t.length < 150
        ) {
          imp(el, 'font-size', '15px');
          imp(el, 'line-height', '1.35');
          imp(el, 'font-weight', '400');
          imp(el, 'margin', '0 0 16px');
          imp(el, 'padding', '0');
          imp(el, 'text-align', 'center');
        }

        /*
         * Marketingtext.
         */
        if (
          t.includes('werbe-') ||
          t.includes('marketing-e-mails')
        ) {
          imp(el, 'font-size', '14px');
          imp(el, 'line-height', '1.3');
          imp(el, 'font-weight', '400');
        }
      });
  }

  function apply() {
    const emails =
      document.querySelectorAll(
        'input[type="email"],' +
        'input[placeholder*="E-Mail" i],' +
        'input[placeholder*="Mail" i]'
      );

    emails.forEach((email) => {
      const popup =
        findPopup(email);

      if (
        !popup ||
        popup === document.body
      ) {
        return;
      }

      popup.dataset.mseSwymV5 = M;

      /*
       * Popup selbst.
       */
      imp(popup, 'width', '90vw');
      imp(popup, 'max-width', '430px');
      imp(popup, 'max-height', '88vh');
      imp(popup, 'overflow-y', 'auto');
      imp(
        popup,
        'padding',
        '24px 20px 22px'
      );
      imp(
        popup,
        'box-sizing',
        'border-box'
      );

      /*
       * Gesamte Popup-Typografie neutralisieren.
       */
      popup
        .querySelectorAll('*')
        .forEach((el) => {
          imp(
            el,
            'font-family',
            'inherit'
          );
        });

      styleLeafText(popup);

      /*
       * MSE_SWYM_REMIND_POPUP_V6_20260918
       *
       * Titel kann bei Swym aus mehreren verschachtelten
       * Elementen bestehen. Deshalb nicht nur Leaf-Nodes,
       * sondern den kompletten Titel-Zweig normalisieren.
       */
      [...popup.querySelectorAll(
        'h1,h2,h3,h4,h5,h6,div,span,p'
      )].forEach((el) => {
        const t =
          norm(el.textContent);

        if (
          t.includes('info an mich') &&
          t.includes('artikel') &&
          t.includes('verfügbar') &&
          t.length < 100
        ) {
          imp(el, 'font-family', 'inherit');
          imp(el, 'font-size', '28px');
          imp(el, 'line-height', '1.12');
          imp(el, 'font-weight', '700');
          imp(el, 'letter-spacing', '0');
          imp(el, 'text-transform', 'none');
          imp(el, 'margin', '0');
          imp(el, 'padding', '0');

          el
            .querySelectorAll('*')
            .forEach((child) => {
              imp(
                child,
                'font-family',
                'inherit'
              );
              imp(
                child,
                'font-size',
                '28px'
              );
              imp(
                child,
                'line-height',
                '1.12'
              );
              imp(
                child,
                'font-weight',
                '700'
              );
              imp(
                child,
                'letter-spacing',
                '0'
              );
            });
        }
      });

      /*
       * Placeholder ist ein Pseudo-Element und kann
       * nicht per inline style gesetzt werden.
       */
      if (
        !document.getElementById(
          'mse-swym-remind-v6-style'
        )
      ) {
        const st =
          document.createElement('style');

        st.id =
          'mse-swym-remind-v6-style';

        st.textContent = `
          [data-mse-swym-v5]
          input[type="email"],
          [data-mse-swym-v5]
          input[type="email"]::placeholder {
            font-family:
              Arial,
              Helvetica,
              sans-serif !important;

            font-size:
              16px !important;

            font-weight:
              400 !important;
          }

          [data-mse-swym-v5]
          input[type="email"]::placeholder {
            opacity:
              .72 !important;
          }

          @media (max-width: 749px) {
            [data-mse-swym-v5] {
              width:
                90vw !important;

              max-width:
                420px !important;

              padding:
                22px 20px 20px !important;
            }
          }
        `;

        document.head.appendChild(st);
      }

      /*
       * E-Mail.
       */
      imp(email, 'height', '50px');
      imp(email, 'min-height', '50px');
      imp(email, 'font-size', '16px');
      imp(email, 'line-height', '1.2');
      imp(email, 'padding', '0 14px');
      imp(
        email,
        'box-sizing',
        'border-box'
      );

      /*
       * CTA.
       */
      popup
        .querySelectorAll(
          'button,input[type="submit"]'
        )
        .forEach((button) => {
          const t =
            norm(
              button.tagName === 'INPUT'
                ? button.value
                : button.textContent
            );

          if (
            !t.includes(
              'benachrichtige mich'
            )
          ) {
            return;
          }

          imp(button, 'height', '50px');
          imp(
            button,
            'min-height',
            '50px'
          );
          imp(
            button,
            'font-size',
            '16px'
          );
          imp(
            button,
            'font-weight',
            '700'
          );
          imp(
            button,
            'line-height',
            '1.2'
          );
          imp(
            button,
            'font-family',
            'inherit'
          );
        });
    });
  }

  let timer = null;
  let observer = null;
  const options = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  };

  const run = () => {
    timer = null;
    observer.disconnect();
    try {
      apply();
    } finally {
      observer.observe(document.documentElement, options);
    }
  };

  const schedule = () => {
    if (timer !== null) return;
    timer = setTimeout(run, 120);
  };

  const start = () => {
    observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, options);
    schedule();
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
